import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

import { SubmitCorrectionDialogComponent } from '@station/dialogs/submit-correction-dialog/submit-correction-dialog/submit-correction-dialog.component';

export interface HasUnsavedCorrections {
    documentsToUpload: { id: number; name: string }[];
    documentId: number | null;
    correctionDiscrepancyMap?: Record<number, number[]>;
    correctionDiscrepancyNoMap?: Record<number, number[]>;
    onModalClosed?: () => void;
    getDocumentDetails?: () => void;
}

export const UnsavedCorrectionsGuard: CanDeactivateFn<HasUnsavedCorrections> = (
    component: HasUnsavedCorrections,
) => {
    if (component.documentsToUpload.length === 0) {
        return of(true);
    }

    const dialog = inject(MatDialog);

    const dialogRef = dialog.open(SubmitCorrectionDialogComponent, {
        data: {
            documentId: component.documentId,
            isFromGuard: true,
            correctionDiscrepancyMap: component.correctionDiscrepancyMap,
            correctionDiscrepancyNoMap: component.correctionDiscrepancyNoMap,
            documents: component.documentsToUpload,
            getDocumentDetails: component.getDocumentDetails
                ? () => component.getDocumentDetails!()
                : undefined,
        },
        maxWidth: '600px',
        minWidth: '200px',
        width: '600px',
    });

    return dialogRef.afterClosed().pipe(
        map((result) => {
            if (result?.deletedCorrectionIds?.length) {
                component.documentsToUpload =
                    component.documentsToUpload.filter(
                        (document) =>
                            !result.deletedCorrectionIds.includes(document.id),
                    );
            }
            if (component.onModalClosed) {
                component.onModalClosed();
            }
            return result?.success === true;
        }),
    );
};
